document.addEventListener('DOMContentLoaded' , () =>{
    // mypage - account - member-modify-page
    if(document.querySelector('.member-modify-page')){
        let checkList = document.querySelectorAll('.social-area--check ul li');

        checkList.forEach( (el , index) =>{
            el.querySelector('.first__btn').addEventListener('click' , ()=>{
                el.querySelector('.hidden-box').classList.toggle('on');
                el.querySelector('.hidden-box--deep').classList.remove('on');
            })
            el.querySelector('.last__btn').addEventListener('click' , ()=>{
                el.querySelector('.hidden-box--deep').classList.toggle('on');
            })
        })
    }
    if(document.querySelector('.mypage-index-page')){
        // 배너
		$('.mypage-banner .mypage-banner__list').slick({
			lazyLoad: 'ondemand',
            dots:true,
            arrows:false,
            autoplay:true,
        })
    }
});
